<template>
  <div v-if="localShow" class="modal-overlay" @click="closeModal">
    <div class="modal-dialog" @click.stop>
      <BaseDialog
        :title="'Create New Labels'"
        :footerButtons="['Create Labels']"
        @cancel="closeModal"
        @footer-click="handleFooterClick"
      >
        <div class="settings__control-group">
          <label>Labels</label>
          <textarea
            ref="labels"
            v-model="labels"
            placeholder="Comma-separated values, eg. label1,label2,etc."
            rows="4"
            cols="50"
          />
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import BaseDialog from '@/components/DilaogTemplate/BaseDialog.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'CreateLabelsModal',
  components: {
    BaseDialog,
  },
  props: {
    datasetId: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  emits: ['label-created', 'closed'],
  data() {
    return {
      labels: '',
      localShow: false,
    };
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  methods: {
    showModal() {
      this.localShow = true;
      this.$nextTick(() => {
        this.$refs.labels.focus();
      });
    },
    closeModal() {
      this.labels = '';
      this.$emit('closed');
      this.localShow = false;
    },
    handleFooterClick(buttonLabel) {
      if (String(buttonLabel || '').toLowerCase() === 'create labels') {
        this.createLabels();
      }
    },
    isJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    parseInput(input) {
      if (this.isJSON(input)) {
        return JSON.parse(input);
      } else {
        return input; // or you can return input.split(",") if you expect comma-separated strings
      }
    },
    async createLabels() {
      let newLabels = [];
      if (this.labels && this.labels !== "") {
        newLabels = this.labels.split(",");
      }
      newLabels = newLabels.map((e) => e.trim()).filter((e) => e !== "");
      if (newLabels.length === 0) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: "Error: Missing valid labels",
          type: 'error',
          position: 'top',
        });
        return;
      }
      await this.dataConnect.addLabel2({
        dataset_id: this.datasetId,
        labels: newLabels.map((e) => ({ "name": e })),
      })
        .then((data) => {
          if (data.error) {
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Error: ${data.error.message}`,
              type: 'error',
              position: 'top',
            });
          } else {
            this.closeModal();
            this.$emit('label-created');
          }
        })
        .catch((error) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Error: ${error}`,
            type: 'error',
            position: 'top',
          });
        });
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/css/themes/auzone/buttons.scss';

.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
}

.modal-dialog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

